import * as z from "zod";

const schema = z.object({
	list: z.record(z.string(), z.array(z.string()))
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantBirthPlaceResModel = {schema, model};
export type ITaxAccountantBirthPlaceResModel = z.infer<typeof TaxAccountantBirthPlaceResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_BIRTH_PLACE_RES: ITaxAccountantBirthPlaceResModel = {
	list: {}
};
